const initialState = {
    noData: false,
    reportingList: [],
    filter: {},
    filters: {},
    fetching: false,
    fetched: false,
    complete_export: false,
    percent_complete: 0,
    page: 1,
    pages: 0,
    error: null
}

export function reportingReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_REPORTING_LIST_TOKEN": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "FETCH_REPORTING_LIST_CLEAR": {
            return { ...state, fetching: false, fetched: true, reportingList: [], page: 1, pages: 0, error: null }
        }

        case "FETCH_REPORTING_LIST": {
            return { ...state, fetching: true, fetched: false, page: action.payload.data.page, error: null }
        }

        case "FETCH_REPORTING_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "FETCH_REPORTING_LIST_FULFILLED": {
            let reportingRecs

            if (state.page === 1)
                reportingRecs = action.payload.data.bridgeReportingRecords
            else {
                reportingRecs = Object.assign([], state.reportingList)
                action.payload.data.bridgeReportingRecords.forEach((rec) => reportingRecs.push(rec))
            }

            return {
                ...state,
                fetching: false,
                fetched: true,
                noData: reportingRecs.length == 0, 
                filters: {
                    templates: action.payload.data.templates,
                    manufacturers: action.payload.data.manufacturers,
                    productLines: action.payload.data.productLines
                },
                pages: action.payload.data.totalRecords,
                reportingList: reportingRecs
            }
        }

        case "FETCH_REPORTING_LIST_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        case "EXPORT_EXCEL_REPORTING": {
            return { ...state, fetching: false, fetched: true, filter: action.payload.data }
        }

        case "PERCENTAGE_COMPLETE_REPORTING": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "EXPORT_START_REPORTING": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }
        case "FINISH_EXPORT_REPORTING": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "COMPLETE_EXPORT_REPORTING": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }    

//TODO - EMULATION FUNCTIONS
/*
        case "SORT_MANUFACTURER": {
            let list = Object.assign([], state.filterList)

            list.sort(function (a, b) {
                if (a.brmfg === null) {
                    a.brmfg = ""
                }

                if (b.brmfg === null) {
                    b.brmfg = ""
                }

                if (a.brmfg.toLowerCase() < b.brmfg.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brmfg.toLowerCase() > b.brmfg.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, sortedList: list }
        }
        case "SORT_PRODUCT_LINE": {
            let list = Object.assign([], state.filterList)

            list.sort(function (a, b) {
                if (a.brlin === null) {
                    a.brlin = ""
                }

                if (b.brlin === null) {
                    b.brlin = ""
                }

                if (a.brlin.toLowerCase() < b.brlin.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brlin.toLowerCase() > b.brlin.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, sortedList: list }
        }
        case "SORT_PART_NUMBER": {
            let list = Object.assign([], state.filterList)

            list.sort(function (a, b) {
                if (a.brpart === null) {
                    a.brpart = ""
                }

                if (b.brpart === null) {
                    b.brpart = ""
                }

                if (a.brpart.toLowerCase() < b.brpart.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.brpart.toLowerCase() > b.brpart.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, sortedList: list }
        }
        case "SORT_REICO_SKU": {
            let list = Object.assign([], state.filterList)

            list.sort(function (a, b) {
                if (a.reicoSKU === null) {
                    a.reicoSKU = ""
                }

                if (b.reicoSKU === null) {
                    b.reicoSKU = ""
                }

                if (a.reicoSKU.toLowerCase() < b.reicoSKU.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.reicoSKU.toLowerCase() > b.reicoSKU.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, sortedList: list }
        }
        case "SORT_PRODUCT_NAME": {
            let list = Object.assign([], state.filterList)

            list.sort(function (a, b) {

                if (a.name === null)
                {
                    a.name = ""
                }

                if (b.name === null)
                {
                    b.name = ""   
                }

                if (a.name.toLowerCase() < b.name.toLowerCase())
                    return action.payload.data ? -1 : 1
                else if (a.name.toLowerCase() > b.name.toLowerCase())
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, sortedList: list }
        }
        case "SORT_PRODUCT_CODE": {
            let list = Object.assign([], state.filterList)

            list.sort(function (a, b) {
                if (a.brprcod < b.brprcod)
                    return action.payload.data ? -1 : 1
                else if (a.brprcod > b.brprcod)
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, sortedList: list }
        }
        case "SORT_UPC": {
            let list = Object.assign([], state.filterList)

            list.sort(function (a, b) {
                if (a.brupc < b.brupc)
                    return action.payload.data ? -1 : 1
                else if (a.brupc > b.brupc)
                    return action.payload.data ? 1 : -1
                else
                    return 0
            })

            return { ...state, sortedList: list }
        }
        case "LOAD_MORE_REPORTING_FULFILLED": {
            let currentList = [];

            if (action.payload.data == null) {
                currentList = Object.assign([], state.searchList)
            }
            else if (action.payload.data.advanced_filter && action.payload.data.advanced_filter == "3") {
                let skuDups = {}

                state.searchList.forEach((prod) => {
                    if (!skuDups.hasOwnProperty(prod.reico_sku))
                        skuDups[prod.reico_sku] = []

                    skuDups[prod.reico_sku].push(prod)
                })

                Object.keys(skuDups).forEach((sku) => {
                    if (skuDups[sku].length > 1) {
                        skuDups[sku].forEach((prod) => {
                            currentList.push(prod)
                        })
                    }
                })
            }
            else if (action.payload.data.advanced_filter && action.payload.data.advanced_filter == "4") {
                let urlDups = {}

                state.searchList.forEach((prod) => {
                    if (!urlDups.hasOwnProperty(prod.url))
                        urlDups[prod.url] = []

                    urlDups[prod.url].push(prod)
                })

                Object.keys(urlDups).forEach((url) => {
                    if (urlDups[url].length > 1) {
                        urlDups[url].forEach((prod) => {
                            currentList.push(prod)
                        })
                    }
                })
            }
            else {
                currentList = Object.assign([], state.searchList)
            }

            if (action.payload.data) {
                currentList = currentList.filter((prod) => {
                    if (action.payload.data.advanced_filter && action.payload.data.advanced_filter == "0" && !prod.epi_blocked)
                        return false
                    if (action.payload.data.advanced_filter && action.payload.data.advanced_filter == "1" && !prod.missing_images)
                        return false
                    if (action.payload.data.advanced_filter && action.payload.data.advanced_filter == "2" && !prod.template_formula)
                        return false
                    if (action.payload.data.advanced_filter && action.payload.data.advanced_filter == "5" && !prod.override)
                        return false
                    if (action.payload.data.advanced_filter && action.payload.data.advanced_filter == "6" && prod.template.length == 1)
                        return false

                    if (action.payload.data.template && !prod.template.includes(action.payload.data.template))
                        return false

                    if (action.payload.data.manufacturer && action.payload.data.manufacturer !== prod.manufacturer)
                        return false

                    if (action.payload.data.product_line && action.payload.data.product_line !== prod.product_line)
                        return false

                    if (action.payload.data.upc && !prod.upc.startsWith(action.payload.data.upc))
                        return false

                    if (action.payload.data.vendor_sku && !prod.vendor_sku.toLowerCase().startsWith(action.payload.data.vendor_sku.toLowerCase()))
                        return false

                    if (action.payload.data.reico_sku && !prod.reico_sku.toLowerCase().startsWith(action.payload.data.reico_sku.toLowerCase()))
                        return false

                    if (action.payload.data.product_name && !prod.product_name.toLowerCase().startsWith(action.payload.data.product_name.toLowerCase()))
                        return false

                    if (action.payload.data.description && !prod.description.toLowerCase().startsWith(action.payload.data.description.toLowerCase()))
                        return false

                    return true
                })
            }

            return { ...state, filter: action.payload.data == null ? {} : action.payload.data, filterList: currentList, sortedList: currentList }
        }
*/
        default:
            return state
    }
}
